var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useEffect } from "react";
import ReactDOM from "react-dom";
import useDropElement from "../../../hooks/use-drop-element";
import useKeyboardEsc from "../../../hooks/use-keyboard-esc";
import useOutsideClick from "../../../hooks/use-outside-click";
import useForwardRef from "../../../hooks/use-forward-ref";
import useDimensionChange from "./useDimensionChange";
import useMakeUpdatePosition from "./useMakeUpdatePosition";
import Container from "./container";
import backdropBlur from "../../templates/layer/mixins/backdropBlur";
import styled from "styled-components";
var Backdrop = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  inset: 0px;\n  pointer-events: all;\n  background-color: rgba(0, 0, 0, 0.3);\n  ", ";\n}\n"], ["\n  position: absolute;\n  inset: 0px;\n  pointer-events: all;\n  background-color: rgba(0, 0, 0, 0.3);\n  ", ";\n}\n"])), backdropBlur);
var defaultAlign = { top: "bottom", left: "left" };
var Drop = forwardRef(function (_a, parentRef) {
    var _b = _a.backdrop, backdrop = _b === void 0 ? false : _b, target = _a.target, _c = _a.align, align = _c === void 0 ? defaultAlign : _c, _d = _a.stretch, stretch = _d === void 0 ? "width" : _d, onClickOutside = _a.onClickOutside, onEsc = _a.onEsc, children = _a.children, _e = _a.canHideTarget, canHideTarget = _e === void 0 ? true : _e, rest = __rest(_a, ["backdrop", "target", "align", "stretch", "onClickOutside", "onEsc", "children", "canHideTarget"]);
    var _f = useForwardRef(parentRef), ref = _f[0], setRef = _f[1];
    var updatePosition = useMakeUpdatePosition(target, ref, align, stretch, canHideTarget);
    useEffect(function () {
        var id = requestAnimationFrame(updatePosition);
        return function () { return cancelAnimationFrame(id); };
    }, [updatePosition]);
    useDimensionChange(target, updatePosition);
    useOutsideClick(ref, onClickOutside, target);
    useKeyboardEsc(onEsc);
    var el = useDropElement();
    return ReactDOM.createPortal(backdrop ? (React.createElement(React.Fragment, null,
        React.createElement(Container, __assign({ ref: setRef, width: { max: "100%" }, column: true, "data-testid": "drop" }, rest), children),
        React.createElement(Backdrop, null))) : (React.createElement(Container, __assign({ ref: setRef, width: { max: "100%" }, column: true, "data-testid": "drop" }, rest), children)), el);
});
export default Drop;
var templateObject_1;
